export default __webpack_public_path__ + "static/media/money-bag-fill.11570a5a.svg";